import React from 'react';
import { LoginForm } from '../components/organisms/LoginForm';
import type { ApiErrorResponse } from '../types/api/common';

/**
 * SignInPage Component
 * 
 * The main sign-in page that uses the LoginForm organism.
 * 
 * Features:
 * - Clean, minimal page structure
 * - Delegates form logic to LoginForm organism
 * - Handles success and error callbacks
 */

export const SignInPage: React.FC = () => {
  console.log('SignInPage rendered');
  
  /**
   * Handle successful login
   */
  const handleLoginSuccess = () => {
    console.log('Login successful');
    // Additional success handling can be added here
  };

  /**
   * Handle login error
   */
  const handleLoginError = (error: ApiErrorResponse) => {
    console.error('Login error:', error);
    // Additional error handling can be added here
  };

  return (
    <div className="flex items-center justify-center">
      <LoginForm
        onSuccess={handleLoginSuccess}
        onError={handleLoginError}
        showSocialLogin={false}
        redirectTo="/home"
      />
    </div>
  );
};

export default SignInPage;

